import store from '../../store'

// TODO maybe rewrite on hook
export const getOrganizationById = orgId => {
    const {
        organizations: { organizationList },
    } = store.getState()
    return organizationList.find(org => org.id === orgId)
}
